import { oz } from '@weft/utils';
import { AnonymousCustomerIngestedSystemEventMessageSchema, InvoiceApprovedSystemEventMessageSchema, OverageSystemEventMessageSchema } from './system-event-message-schemas';
import { UpcomingRenewalSystemEventMessageSchema } from './system-event-message-schemas/upcoming-renewal-message';

export const SystemEventMessageSchema = oz.discriminatedUnion('eventType', [
  OverageSystemEventMessageSchema,
  AnonymousCustomerIngestedSystemEventMessageSchema,
  UpcomingRenewalSystemEventMessageSchema,
  InvoiceApprovedSystemEventMessageSchema,
]);

export type SystemEventMessage = oz.TypeOf<typeof SystemEventMessageSchema>;